<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value="" disabled selected) {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.value" v-if="amount >= option.min && amount <= option.max") {{ option.text }} ({{ getBalance(option.value) }})
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    filterBalance: {
      type: Boolean,
      default: false
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    options: [
      {
        value: "GSPAYSOLUTION",
        text: "GSPAYSOLUTION",
        min: 1,
        max: 3000
      },
      {
        value: "PEPAY",
        text: "PEPAY",
        min: 50,
        max: 4999
      },
      {
        value: "UPAY",
        text: "UPAY",
        min: 50,
        max: 10000
      },
    ],
    balanceList: [],
    feedback: {
      success: true,
      status: ""
    },
  }),
  mounted: function() {
    this.options.forEach(e => {
      this.getProviderBalance(e["value"]);
    });
  },
  methods: {
    getBalance: function (pg) {
      var obj = this.balanceList.filter(ele => { return ele.pg == pg });
      if (obj != null && obj.length > 0)
        return obj[0]['balance'];

      return 0;
    },
    getProviderBalance(pg) {
      this.loading = true;
      this.$store
        .dispatch("user/getPGProviderBalance", { pg })
        .then(response => {
          this.loading = false;
          // console.log(response)
          this.feedback.success = response.success;
          this.feedback.status = response.status;
          if (this.feedback.success == true) {
            if (response.obj != null && response.obj !== "undefined") {
              this.balanceList.push(response.obj)
              // this.balanceObj[pg] = response.obj['balance']
            }
          }
        })
        .catch(response => {
          this.loading = false;
          this.feedback.success = response.success;
          // this.submission.status =  response.status;
          this.feedback.status = this.$t("error." + response.status);
        });
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
